// Import images
import GJGardnerLogo from "../../assets/images/dh-gj-gardner-logo.jpg";
import PerryHomesLogo from "../../assets/images/dh-perry-homes-logo.jpg";
import CoralHomesLogo from "../../assets/images/dh-coral-homes-logo.png";

// Import Perry Homes images
import PerryHomesFacade from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Facade.jpg";
import PerryHomes5 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (5).jpg";
import PerryHomes7 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (7).jpg";
import PerryHomes8 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (8).jpg";
import PerryHomes9 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (9).jpg";
import PerryHomes11 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (11).jpg";
import PerryHomes22 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (22).jpg";
import PerryHomes24 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (24).jpg";
import PerryHomes26 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (26).jpg";
import PerryHomes28 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (28).jpg";
import PerryHomes37 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (37).jpg";
import PerryHomes40 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (40).jpg";
import PerryHomes41 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (41).jpg";
import PerryHomes45 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (45).jpg";
import PerryHomes52 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (52).jpg";
import PerryHomes53 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (53).jpg";
import PerryHomes54 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (54).jpg";

// Import Perry Homes 2 images

import ThePalms00 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_Facade.jpg";
import ThePalms10 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (10).jpg";
import ThePalms21 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (21).jpg";
import ThePalms22 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (22).jpg";
import ThePalms35 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (35).jpg";
import ThePalms40 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (40).jpg";
import ThePalms45 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (45).jpg";
import ThePalms52 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (52).jpg";
import ThePalms55 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (55).jpg";
import ThePalms56 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (56).jpg";
import ThePalms75 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (75).jpg";
import ThePalms81 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (81).jpg";
import ThePalms86 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (86).jpg";

// Builder data
const buildersData = {
    gjgardner: {
        houses: [
            {
                id: "millbrook271",
                logo: GJGardnerLogo,
                name: "GJ Gardner",
                description:
                    "Made for entertaining and everyday living, the Millbrook is a modern family home designed with plenty of space and added luxurious features for the whole family to enjoy. The heart of the home provides an enjoyable open plan living space, featuring a stunning kitchen and butler’s pantry adjoined by the dining and family rooms that extend outdoors to the rear alfresco and a central private courtyard. A generous master suite with large walk-in robe and its lavishly outfitted ensuite is privately positioned behind a separate lounge room at the front of the home; an ideal space to retreat and unwind. Additional bedrooms and the family bathroom at the rear of the home provide private spaces for the rest of the household. Extra features compliment the design with the inclusion of a study or mudroom making the Millbrook an ideal place for any family to call home.",
                homeName: "Millbrook 271",
                homeDescription: "",
                homeImages: [
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FMillbrook%20271%2Fmillbrook-271-facade.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FMillbrook%20271%2Fmillbrook-271-living.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FMillbrook%20271%2Fmillbrook-271-living-2.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FMillbrook%20271%2Fmillbrook-271-living-3.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FMillbrook%20271%2Fmillbrook-271-living-4.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FMillbrook%20271%2Fmillbrook-271-bath.png",
                ],
                beds: 4,
                baths: 2.5,
                cars: 2,
                livingRooms: undefined,
                buttonText: "Find out more about GJ Gardner",
                buttonLink: "https://www.gjgardner.com.au",
                locationText: "5 Windrow Ave, Cumbalum, NSW",
                locationLink:
                    "https://www.google.com/maps?ll=-28.815235,153.533206&z=18&t=m&hl=en&gl=AU&mapclient=embed&q=5+Windrow+Ave+Cumbalum+NSW+2478",
                virtualTourButton: {
                    text: "Click here for a virtual tour",
                    link: "https://www.gjgardner.com.au/display-homes/5-windrow-avenue-cumbalum-nsw-2478-743/",
                },
            },
            {
                id: "freshwater341",
                logo: GJGardnerLogo,
                name: "GJ Gardner",
                description:
                    "The Freshwater is the perfect home for large and growing families with an abundance of space over two functional stories. Entertain family and friends in the large open plan living space where a generous Kitchen and Butler’s Pantry connect effortlessly with the family and dining areas which extend outdoors to the rear covered Alfresco. Boasting from the upper floor, the master bedroom is luxurious in size, opening onto a Balcony and complete with a huge well equipped ensuite and walk in robe. A separate lounge room to the front of home, a central Sitting room upstairs and four additional bedrooms including the 5th guest suite downstairs provide plenty of space to retreat, relax and unwind.",
                homeName: "Freshwater 341",
                homeDescription: "",
                homeImages: [
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-facade.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-living.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-living-2.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-living-3.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-kitchen.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-bath.png",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FFreshwater%20341%2Ffreshwater341-bed.png",
                ],
                beds: 5,
                baths: 3.5,
                cars: 2,
                livingRooms: undefined,
                buttonText: "Find out more about GJ Gardner",
                buttonLink: "https://www.gjgardner.com.au",
                locationText: "3 Windrow Avenue, Cumbalum, NSW, 2478",
                locationLink:
                    "https://www.google.com/maps?ll=-28.815334,153.533057&z=17&t=m&hl=en&gl=AU&mapclient=embed&q=3+Windrow+Ave+Cumbalum+NSW+2478",
                virtualTourButton: {
                    text: "Click here for a virtual tour",
                    link: "https://www.gjgardner.com.au/display-homes/3-windrow-avenue-cumbalum-nsw-2478-742/",
                },
            },
        ],
        contactDetails: {
            openingHoursSchedule: [
                { day: "Monday", hours: "12:00 – 16:00" },
                { day: "Tuesday", hours: "10:00 – 16:00" },
                { day: "Wednesday", hours: "12:00 – 16:00" },
                { day: "Thursday", hours: "Closed" },
                { day: "Friday", hours: "10:00 – 16:00" },
                { day: "Saturday", hours: "10:00 – 16:00" },
                { day: "Sunday", hours: "10:00 – 16:00" },
            ],
            // christmasClosure: "23rd December from 12pm - 1st January",
            addressText: "3 Windrow Avenue, Cumbalum, NSW, 2478",
            addressLink:
                "https://www.google.com/maps?ll=-28.815334,153.533057&z=17&t=m&hl=en&gl=AU&mapclient=embed&q=3+Windrow+Ave+Cumbalum+NSW+2478",
            salesContacts: [
                {
                    name: "Cameron Walters",
                    email: "cameron.walters@gjgardner.com.au",
                },
                {
                    name: "Kevin Rizk",
                    email: "kevin.rizk@gjgardner.com.au",
                },
                {
                    name: "Kane Munro",
                    email: "kanemunro@gjgardner.com.au",
                },
                {
                    name: "Harry Hyett",
                    email: "harry.hyett@gjgardner.com.au",
                },
            ],
            phoneText: "0411 740 878",
        },
    },
    perryhomes: {
        houses: [
            {
                id: "perryhomes",
                logo: PerryHomesLogo,
                name: "Perry Homes",
                description:
                    "A flexible home designed for the changing lives of a growing family. To the rear of the home is the master bedroom complete with walk-in robe and ensuite along with two further bedrooms and the main bathroom. To the front of the property is the fourth bedroom which benefits from its own bathroom. This combined with the rumpus room can easily be divided from the rest of the house making it perfect for dual living should a family member need to reside with you or you have a teenager craving their own space!",
                homeName: "Aria 28",
                homeDescription:
                    "The expansive open plan living area boasts a gourmet kitchen complete with butler's pantry and overlooks the outdoor entertaining area.",
                homeImages: [
                    PerryHomesFacade,
                    PerryHomes5,
                    PerryHomes7,
                    PerryHomes8,
                    PerryHomes9,
                    PerryHomes11,
                    PerryHomes22,
                    PerryHomes24,
                    PerryHomes26,
                    PerryHomes28,
                    PerryHomes37,
                    PerryHomes40,
                    PerryHomes41,
                    PerryHomes45,
                    PerryHomes52,
                    PerryHomes53,
                    PerryHomes54,
                ],
                beds: 4,
                baths: 3,
                cars: 2,
                livingRooms: 2,
                openHours: "Open Saturday to Wednesday, 10am - 4pm",
                buttonText: "Find out more about Perry Homes",
                buttonLink: "https://www.perryhomes.com.au",
                locationText: "7 Windrow Ave, Cumbalum 2478",
                locationLink: "https://maps.app.goo.gl/BNEhzBuPW4c7wrYP7",
                virtualTourButton: {
                    text: "Click here for a virtual tour",
                    link: "https://my.matterport.com/show/?m=bYrfQV4FSQ9",
                },
            },
            {
                id: "perryhomes2",
                logo: PerryHomesLogo,
                name: "Perry Homes",
                description:
                    "The stunning Palms design is the perfect family two storey home, boasting four bedrooms and three living spaces. As you walk into the home there is a guest suite located to the front of the property offering separation from the rest of the home. To the rear of the home is a dedicated media room and the open plan living area. The kitchen is an entertainer’s dream with ample bench space and a large walk-in pantry.",
                homeName: "The Palms",
                homeDescription:
                    "Upstairs, the expansive mastersuite with a large walk-in robe and ensuite provides the perfect retreat. There are two further bedrooms – both with walk-in robes and the option to have ensuites or a shared bathroom.",
                homeImages: [
                    ThePalms00,
                    ThePalms10,
                    ThePalms21,
                    ThePalms22,
                    ThePalms35,
                    ThePalms40,
                    ThePalms45,
                    ThePalms52,
                    ThePalms55,
                    ThePalms56,
                    ThePalms75,
                    ThePalms81,
                    ThePalms86,
                ],
                beds: 4,
                baths: 3,
                cars: 2,
                livingRooms: 3,
                openHours: "Open Saturday to Wednesday, 10am - 4pm",
                buttonText: "Find out more about Perry Homes",
                buttonLink: "https://www.perryhomes.com.au",
                locationText: "9 Windrow Ave, Cumbalum 2478",
                locationLink: "https://maps.app.goo.gl/bNCwDb9hvqTnisTR8",
                virtualTourButton: {
                    text: "Click here for a virtual tour",
                    link: "https://my.matterport.com/show/?m=zFHhYwLvgmh",
                },
            },
        ],
        contactDetails: {
            openHours: "Open Saturday to Wednesday, 10am - 4pm",
            // christmasClosure: "17th December - 6th January",
            consultantName: "Chris Littlewood",
            phoneText: "0411 611 842",
            emailText: "chris.littlewood@perryhomes.com.au",
        },
    },
    coralhomes: {
        houses: [
            {
                id: "lisbon276n",
                logo: CoralHomesLogo,
                name: "Coral Homes",
                description:
                    "Coral Homes offer a range of new innovative home designs at an affordable price. The leading home builder has over 35 years' experience and is best known for their competitive prices and value for money. Whether you're buying your first home, looking for more room to raise a family or downsizing to something more manageable, Coral Homes will have a home design to suit your land and lifestyle.",
                homeName: "Lisbon 276N",
                homeDescription:
                    "The Lisbon Series welcomes you with a sense of spaciousness from the moment you step inside. The thoughtfully designed layout allows for an effortless flow between the living spaces, with the heart of the home opening seamlessly to a generous outdoor alfresco area, perfect for entertaining. The functional design maximises space with multiple living areas and offers privacy by separating the master retreat from the kids’ bedrooms and activity zone.",
                homeImages: [
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Lodge-Facade-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Activity-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Dining_Kitchen_Family-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Ensuite-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Family-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Kitchen-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Master-Bedroom-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon-276N-Ballina-Media-1250x716.jpg",
                    // "http://s3.intrapac.io/banyan-hill-site-media/homes%2FLisbon%20276N%2FLisbon%20276N%20Floorplan.png",
                ],
                beds: 4,
                baths: 2.5,
                cars: 2,
                livingRooms: 3,
                buttonText: "Find out more about Coral Homes",
                buttonLink: "https://www.coralhomes.com.au",
                locationText: "2 Windrow Avenue, Cumbalum, NSW 2478",
                locationLink: "https://www.google.com/maps?q=2+Windrow+Avenue,+Cumbalum,+NSW+2478+Ballina+%26%238211;+Banyan+Hill+Estate",
                virtualTourButton: {
                    text: "Click here for a virtual tour",
                    link: "https://coralhomes.com.au/home-designs/lisbon-series/",
                },
            },
            {
                id: "noosaville248n",
                logo: CoralHomesLogo,
                name: "Coral Homes",
                // description:
                //     "Coral Homes offer a range of new innovative home designs at an affordable price. The leading home builder has over 35 years' experience and is best known for their competitive prices and value for money. Whether you're buying your first home, looking for more room to raise a family or downsizing to something more manageable, Coral Homes will have a home design to suit your land and lifestyle.",
                homeName: "Noosaville 248N",
                homeDescription:
                    "The well-considered floorplans are designed to suit the entire family. The Noosaville Series provides relaxed, functional living with great features such as a study nook, walk-in robes in most bedrooms and two living rooms.",
                homeImages: [
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-East-Hamptons-Facade-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-Ensuite-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-Family_Dining_Kitchen-1-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-Kitchen-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-Living-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-Master-Bedroom_Ensuite-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville-248N-Ballina-Master-Bedroom-1250x716.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%2025%20(Ballina)%20-%20Master%20Bedroom.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%2025%20(Ballina)%20-%20Living_Dining_Kitchen.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%2025%20(Ballina)%20-%20Kitchen.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%2025%20(Ballina)%20-%20Kitchen_Living.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%2025%20(Ballina)%20-%20Kitchen%202.jpg",
                    "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%2025%20(Ballina)%20-%20Ensuite.jpg",
                    // "http://s3.intrapac.io/banyan-hill-site-media/homes%2FNOOSAVILLE%20Coral%20Homes%20%2FNoosaville%20248N%20Floorplan.png",
                ],
                beds: 4,
                baths: 2.5,
                cars: 2,
                livingRooms: 2,
                buttonText: "Find out more about Coral Homes",
                buttonLink: "https://www.coralhomes.com.au",
                locationText: "2 Windrow Avenue, Cumbalum, NSW 2478",
                locationLink: "https://www.google.com/maps?q=2+Windrow+Avenue,+Cumbalum,+NSW+2478+Ballina+%26%238211;+Banyan+Hill+Estate",
                virtualTourButton: {
                    text: "Click here for a virtual tour",
                    link: "https://coralhomes.com.au/home-designs/noosaville-series/#hd-57302",
                },
            },
        ],
        contactDetails: {
            openHours: "Monday – Sunday 10am – 5pm",
            // christmasClosure: "20th December - 2nd January",
            addressText: "2 Windrow Avenue, Cumbalum, NSW 2478",
            addressLink:
                "https://www.google.com/maps?q=2+Windrow+Avenue,+Cumbalum,+NSW+2478+Ballina+%26%238211;+Banyan+Hill+Estate",
            consultantName: "Haley Corrigan",
            consultantTitle: "New Homes Consultant",
            phoneText: "0409 516 970",
            emailText: "h.corrigan@coralhomes.com.au",
        },
    },
};

export default buildersData;
